export interface Responsable {
  name: string;
  surname: string;
  npi: string;
}

export interface Protocol {
  name: string;
  assessed?: boolean;
  modified?: boolean;
  demonstrated?: boolean;
}

export interface PlanProtocol extends Protocol {
  plan_id: number | null;
}

export interface DiscussedPlanProtocol {
  plan_id: number | null;
  name: string;
  assessed?: boolean;
  modified?: boolean;
  discussed?: boolean;
}

export interface CaregiverGoalProtocol {
  plan_id: number | null;
  name: string;
  percentage_achieved?: number;
}

export interface TeacherGoalProtocol {
  plan_id: number | null;
  name: string;
  percentage_achieved?: number;
}

export interface RbtGoalProtocol {
  plan_id: number | null;
  name: string;
  percentage_achieved?: number;
}

export type AssessmentToolType = 'observation/parent interview' | 'report';

export type AssessmentToolStage = 'initial assessment' | 'reassessment';

// Import note types for the union type
import { NoteBcbaV2 } from './note-bcba.v2.model';
import { NoteCombinedV2 } from './note-combined.v2.model';
import { NoteRbtV2 } from './note.rbt.v2.model';

// Union type for all note types
export type Note = NoteBcbaV2 | NoteRbtV2 | NoteCombinedV2;
